import VideoPreview from './videoPreview';

export default VideoPreview;
